export default {
  methods: {
    truncate(value, length = 75) {
      return value?.length > length
        ? `${value.substring(0, (length - 3))}...`
        : value
    },
  },
}
